// src/components/home/Banner.jsx
import React from 'react';
import image from '../../assets/images/violinsideprofile.jpg'

const Banner = () => {
  return (
    <div className="relative h-96 rounded-lg overflow-hidden">
      <img 
        src={image}
        alt=""
        className="absolute w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-gray-900 via-gray-900/70 to-transparent flex flex-col justify-center p-8">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
          Esbjörn Falk
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 max-w-xl">
            Swedish Classical Composer
        </p>
      </div>
    </div>
  );
};

export default Banner;